import styled from 'styled-components';

import { t } from 'localization/utils/t';

const TP = 'search.components.searchGrid.SerchNoResults';

export const SearchNoResults = () => {
  return (
    <SearchNoResults.Wrapper>
      <p>
        {t(
          `${TP}.noResults`,
          'There were no matching results. Please try a different search or reset your filters.',
        )}
      </p>
    </SearchNoResults.Wrapper>
  );
};

SearchNoResults.Wrapper = styled.div`
  color: ${({ theme }) => theme.navigation.textColor};
  min-height: 400px;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  text-align: center;

  > p {
    margin: 16px;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.mediumSmall}px) {
    min-height: auto;
  }
`;

export default SearchNoResults;
